module.exports = __webpack_public_path__ + "media/images/profile_logo/thumbs_empty_consultant-b342433b6789d99d0cb99766566d3618.png";